import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";
import type { MCPStatus } from "@/types";

interface StatusPillProps {
  status: MCPStatus;
  compact?: boolean;
}

export const StatusPill = ({ status, compact = false }: StatusPillProps) => {
  const styles = {
    online: "bg-emerald-50 text-emerald-700 border border-emerald-100",
    offline: "bg-rose-50 text-rose-700 border border-rose-100",
    connecting: "bg-amber-50 text-amber-700 border border-amber-100",
  } as const;

  if (compact) {
    return (
      <span
        className={cn(
          "inline-flex items-center justify-center rounded-full p-1.5 sm:hidden",
          styles[status],
        )}
        title={status === "online" ? "Online" : status === "connecting" ? "Connecting" : "Offline"}
      >
        {status === "connecting" ? (
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
        ) : (
          <span className="h-2 w-2 rounded-full bg-current" />
        )}
      </span>
    );
  }

  return (
    <span
      className={cn(
      "inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold",
      styles[status],
      )}
    >
      {status === "connecting" ? (
      <Loader2 className="h-3.5 w-3.5 animate-spin" />
      ) : (
      <span className="h-2 w-2 rounded-full bg-current" />
      )}
      <span className="hidden sm:inline">
      {status === "online" ? "Online" : status === "connecting" ? "Connecting" : "Offline"}
      </span>
    </span>
  );
};
